<template>
<div>
    <c-form-group class="form-group required-field">
        <label for="postal_code">CEP</label>
        <input 
            type="text" 
            class="form-input form-wide mb-2" 
            v-model="postal_code" 
            id="postal_code" 
            @change="consultaCep(postal_code)"
            v-mask="'#####-###'"
            name="postal_code"
        />
        <div v-if="$v.postal_code.$error && !$v.postal_code.required" class="required">* CEP obrigatório</div>
    </c-form-group>

    <c-form-group class="form-group required-field">
        <label for="city">Cidade</label>
        <input 
            type="text" 
            class="form-input form-wide mb-2 disabled" 
            id="city" 
            v-model="city" 
            readonly
            name="city"
        />
        <div v-if="$v.city.$error && !$v.city.required" class="required">* Cidade obrigatório</div>
    </c-form-group>

    <c-form-group class="form-group required-field">
        <label for="uf">UF</label>
        <input 
            type="text" 
            class="form-input form-wide mb-2 disabled" 
            id="uf" 
            v-model="uf" 
            readonly
            name="uf"
        />
        <div v-if="$v.uf.$error && !$v.uf.required" class="required">* UF obrigatório</div>
    </c-form-group>

    <c-form-group class="form-group required-field">
        <label for="district">Bairro</label>
        <input 
            type="text" 
            class="form-input form-wide mb-2" 
            id="district" 
            v-model="district" 
            name="district"
        />
        <div v-if="$v.district.$error && !$v.district.required" class="required">* Bairro obrigatório</div>
    </c-form-group>
    
    <c-form-group class="form-group required-field">
        <label for="address">Endereço</label>
        <input 
            type="text" 
            class="form-input form-wide mb-2" 
            id="address" 
            v-model="address" 
            name="address"
        />
        <div v-if="$v.address.$error && !$v.address.required" class="required">* Endereço obrigatório</div>
    </c-form-group>

    <c-form-group class="form-group required-field">
        <label for="number">Número</label>
        <input 
            type="text" 
            class="form-input form-wide mb-2" 
            id="number" 
            v-model="number" 
            name="number"
        />
        <div v-if="$v.number.$error && !$v.number.required" class="required">* Número obrigatório</div>
    </c-form-group>
    <c-form-group class="form-group required-field">
        <label for="complement">Complemento</label>
        <input 
            type="text" 
            class="form-input form-wide mb-2" 
            id="complement" 
            v-model="complement" 
            name="complement"
        />
        <div v-if="$v.complement.$error && !$v.complement.required" class="required">* Complemento obrigatório</div>
    </c-form-group>

    <c-form-group class="form-group required-field">
        <label for="phone">Telefone</label>
        <input 
            type="text" 
            class="form-input form-wide mb-2" 
            id="phone" 
            v-model="phone" 
            v-mask="'(##) #####-####'"
            name="phone"
        />
        <div v-if="$v.phone.$error && !$v.phone.required" class="required">* Telefone obrigatório</div>
    </c-form-group>
    <c-form-group class="form-group required-field">
        <div class="d-flex">
            <input 
                type="checkbox" 
                class="form-input form-wide required" 
                id="accepted_terms" 
                v-model="accepted_terms" 
                name="accepted_terms"
                style="width:20px;margin-top: 3px;margin-right:5px"
            />
            <label for="accepted_terms">Li e aceito as <c-link style="font-weight: 600;" target="_blank" :href="$baseUrl+'page/politica-privacidade'">políticas de privacidade</c-link></label>
        </div>
        
        <div v-if="$v.accepted_terms.$error && !$v.accepted_terms.required" class="required"> Para continuar é necessário aceitar as políticas de privacidade,<br> de acordo o art. 7º, inciso I, da Lei Geral de Proteção de Dados<br> nº 13.709/2018. </div>
    </c-form-group>

</div>
</template>

<script>
import { required, minLength, requiredIf, sameAs, email } from 'vuelidate/lib/validators'
import ConsultaCep from '../../../api/consultaCep'
import { CFormGroup, CLink } from '../../Styles/Components/styled'

export default {
    name:'Endereco',
    components: {
        'c-form-group': CFormGroup,
        'c-link': CLink
    },
    data() {
        return {
            postal_code: null,
            address: null,
            city: null,
            uf: null,
            number: null,
            complement: null,
            district: null,
            phone: null,
            ibge: null,
            accepted_terms:null,
        }
    },
    validations: {
        postal_code: {required},
        city: {required},
        address: {required},
        uf: {required},
        number: {required},
        complement: {required},
        district: {required},
        phone: {required},
        accepted_terms:{required}
    },
    methods: {
        validate() {
            this.$v.$touch();
            var isValid = !this.$v.$invalid
            this.$emit('on-validate', this.$data, isValid)
            return isValid
        },
        async consultaCep(cep_consulta) {
            if(!cep_consulta) {
                return
            }
            try {
                let {
                    erro=null, 
                    bairro=null, 
                    cep=null, 
                    complemento=null,
                    gia=null, 
                    ibge=null, 
                    localidade=null, 
                    logradouro=null, 
                    uf=null, 
                    unidade=null

                } = await ConsultaCep.get(cep_consulta)
                if(erro) {
                    alert('CEP inválido!')
                    return
                }
                    this.city = localidade.toUpperCase()
                    this.uf = uf.toUpperCase()
                    this.district = bairro.toUpperCase()
                    this.address = logradouro.toUpperCase()
                    this.complement = complemento
                    this.ibge = ibge
            } catch(error) {
                alert(error)
            }
        },
    }
}
</script>